module.exports = "/assets/restaurant-photo.png?LsRKLDH";